import ViewLocalSettings from "../../../../common/view-local-settings"
import {BreakdownConfig, TasksViewAppSettings} from "../../@types"

export default class TasksView_LocalSettings extends ViewLocalSettings<TasksViewAppSettings> {

    protected _expanded                 : ID[]              // expanded items IDs (is used when default state is collapsed, e.g. Table)
    protected _columnsWidth             : any               // redefined columns width data
    protected _sortedItemsIds           : ID[]  = []        // items in order (sorting manual)
    protected _tasksQuickFilterUserId?  : ID                // user id for quick tasks filter

    protected _orderedItemsIds          : ID[] = []         // for DND reorder to save positions  // used in portfolio summary
    protected _showSidePanel            : boolean           // show side panel with quick filter
    protected _breakdown?               : BreakdownConfig

    constructor(localStorageKey:string) {
        super(localStorageKey);

        const values                    = this._readFromLocalStorage()

        this._expanded                  = _.get(values, 'expanded', [])
        this._columnsWidth              = _.get(values, 'columnsWidth', {})
        this._tasksQuickFilterUserId    = _.get(values, 'tasksQuickFilterUserId', undefined)
        this._sortedItemsIds            = _.get(values, 'sortedItemsIds', [])
        this._orderedItemsIds           = _.get(values, 'orderedItemsIds',   [])
        this._showSidePanel             = _.get(values, 'showSidePanel', false)
        this._breakdown                 = _.get(values, 'breakdown', undefined)
    }

    get expanded() {
        return this._expanded
    }

    set expanded(value:any) {
        this._expanded = value
        this.save()
    }

    get columnsWidth() {
        return this._columnsWidth
    }

    set columnsWidth(value:any) {
        this._columnsWidth = value
        this.save()
    }

    get tasksQuickFilterUserId() {
        return this._tasksQuickFilterUserId
    }

    set tasksQuickFilterUserId(value: ID | undefined) {
        this._tasksQuickFilterUserId = value
        this.save()
    }

    get sortedItemsIds() {
        return this._sortedItemsIds
    }

    set sortedItemsIds(value:any) {
        this._sortedItemsIds = value
        this.save()
    }

    get orderedItemsIds() {
        return this._orderedItemsIds
    }

    set orderedItemsIds(value:any) {
        this._orderedItemsIds = value
        this.save()
    }

    get showSidePanel() {
        return this._showSidePanel
    }

    set showSidePanel(value:any) {
        this._showSidePanel = value
        this.save()
    }

    get breakdown() {
        return this._breakdown
    }

    set breakdown(value:any) {
        this._breakdown = value
        this.save()
    }

    toObject(): any {
        return {
            appSettings             : this.appSettings,
            expanded                : this.expanded,
            columnsWidth            : this.columnsWidth,
            tasksQuickFilterUserId  : this.tasksQuickFilterUserId,
            sortedItemsIds          : this.sortedItemsIds,
            orderedItemsIds         : this.orderedItemsIds,
            showSidePanel           : this.showSidePanel,
            breakdown               : this.breakdown,
        }
    }
}
